import React from 'react';
import IconType from '@ui/Icon/StaticIcon/IconType';
import { StaticIcon } from '@ui/Icon/StaticIcon/StaticIcon';
import Text, { TextVariant } from '@ui/Text/Text';

export default function Star({ text }: { text: string }) {
  return (
    <div className="flex items-center gap-2">
      <div className="flex p-1.5">
        <StaticIcon icon={IconType.starFilled} />
      </div>
      <Text content={text} variant={TextVariant.TextBodyMD} />
    </div>
  );
}
